/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'three-buildings': {
    width: 484.738,
    height: 484.738,
    viewBox: '0 0 484.738 484.738',
    data: '<path pid="0" d="M131.012 438.372h85.624v-87.557h51.467v87.557h85.624V46.366H131.012v392.006zM257.993 92.564h51.466v51.467h-51.466V92.564zm0 82.715h51.466v51.467h-51.466v-51.467zm0 82.713h51.466v51.467h-51.466v-51.467zM175.279 92.564h51.466v51.467h-51.466V92.564zm0 82.715h51.466v51.467h-51.466v-51.467zm0 82.713h51.466v51.467h-51.466v-51.467zM373.719 81.482V358.66h33.065v79.712h77.954V81.482H373.719zm70.718 239.527H397.58v-46.856h46.856v46.856zm0-75.306H397.58v-46.855h46.856v46.855zm0-75.305H397.58v-46.855h46.856v46.855zM0 438.372h77.954V358.66h33.065V81.482H0v356.89zm40.302-314.829h46.856v46.855H40.302v-46.855zm0 75.305h46.856v46.855H40.302v-46.855zm0 75.303h46.856v46.855H40.302v-46.855z"/>'
  }
})
